import styled from 'styled-components';
import {COLORS, SCREEN_MD} from 'shared/consts';
import {toEm, toRem} from 'shared/helpers';

export const ConsentPage = styled.main`
  min-height: 100dvh;
  padding: ${toRem(32)} ${toRem(20)};
  display: flex;
  justify-content: center;
  background: ${COLORS.BG.SURFACE3};

  @media (width < ${toEm(SCREEN_MD)}) {
    padding: ${toRem(16)};
  }
`;

export const ConsentCard = styled.section`
  width: min(100%, ${toRem(860)});
  padding: ${toRem(32)};
  border-radius: ${toRem(28)};
  background: ${COLORS.BG.PAGE};

  @media (width < ${toEm(SCREEN_MD)}) {
    padding: ${toRem(20)};
    border-radius: ${toRem(20)};
  }
`;

export const ConsentHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${toRem(16)};
  margin-bottom: ${toRem(32)};
`;

export const ConsentVersion = styled.span`
  padding: ${toRem(6)} ${toRem(10)};
  border-radius: ${toRem(6)};
  color: ${COLORS.FG.SOFT};
  background: ${COLORS.BG.SURFACE2};
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
`;

export const ConsentArticle = styled.article`
  color: ${COLORS.FG.DEFAULT};

  h1 {
    margin: 0 0 ${toRem(20)};
    font-size: ${toRem(32)};
    line-height: ${38 / 32};
  }

  h2 {
    margin: ${toRem(32)} 0 ${toRem(12)};
    font-size: ${toRem(20)};
    line-height: ${24 / 20};
  }

  p,
  li {
    font-size: ${toRem(16)};
    line-height: ${24 / 16};
  }

  p {
    margin: 0;
  }

  p + p {
    margin-top: ${toRem(16)};
  }

  a {
    color: ${COLORS.ACCENT.DEFAULT};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  @media (width < ${toEm(SCREEN_MD)}) {
    h1 {
      font-size: ${toRem(24)};
      line-height: ${30 / 24};
    }
  }
`;

export const ConsentLead = styled.p`
  padding: ${toRem(18)};
  border-radius: ${toRem(12)};
  background: ${COLORS.BG.SURFACE2};
`;

export const ConsentList = styled.ul`
  margin: 0;
  padding-left: ${toRem(22)};

  li + li {
    margin-top: ${toRem(10)};
  }
`;

export const ConsentFooter = styled.footer`
  margin-top: ${toRem(32)};
`;
